import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

function copyToArray(results) {
  let retArray = []

  results.forEach(doc => {
    retArray.push(processDoc(doc))
  })

  return retArray
}

function processDoc(doc) {
  let obj = doc.data()
  obj.id = doc.id
  obj._ref = doc
  return obj
}

function recursively_gen_tree(tree, id_map) {
  Object.keys(tree).forEach(key => {
    let item = id_map[key]
    if (item.children) {
      item.children.forEach(e => {
        tree[key].children[e.id] = {
          'children': Object()
        }
      })
    }
    recursively_gen_tree(tree[key].children, id_map)
  })
}

function deleteObjectiveFromParent(state, oid) {
  let qid = state.objectives_by_id[oid].parent.id
  let index = -1
  state.quests_by_id[qid].objectives.forEach((e, i) => {
    if (e.id == oid) {
      index = i
    }
  })
  if (index >= 0) {
    state.quests_by_id[qid].objectives.splice(index, 1)
  }
}

// handle page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('fetchUserProfile')

    const userRef = fb.usersCollection.doc(user.uid)
    userRef.onSnapshot(doc => {
      store.commit('setUserProfile', doc.data())
    })

    refreshAll()
  }
})

function refreshAll() {
  store.dispatch('refreshQuests')
  store.dispatch('refreshObjectives')
  store.dispatch('refreshLogs')
}

function questParentLookup(quests_by_id) {
  let quest_to_parents = Object()
  let q = []

  Object.keys(quests_by_id).forEach(qid => {
    if (!quests_by_id[qid].parent) {
      quest_to_parents[qid] = []
      q.push(qid)
    }
  })
  while (q.length) {
    let qid = q.pop()
    if (quests_by_id[qid].children) {
      quests_by_id[qid].children.forEach(c => {
        quest_to_parents[c.id] = quest_to_parents[qid].concat([qid])
        q.push(c.id)
      })
    }
  }
  return quest_to_parents
}

function getQuestOrder(quests_by_id) {
  let q = []
  let dfs = []
  Object.keys(quests_by_id).forEach(qid => {
    if (!quests_by_id[qid].parent) {
      q.push(qid)
    }
  })
  while (q.length) {
    let qid = q.pop()
    dfs.push(qid)
    if (quests_by_id[qid].children) {
      let cq = []
      quests_by_id[qid].children.forEach(c => {
        cq.push(c.id)
      })
      q = q.concat(cq)
    }
  }

  return dfs
}

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: {},
    quests_by_id: {},
    quest_to_parents: {},
    quest_order: [],
    objectives_by_id: {},
    logs: [],
    userRef: null
  },
  mutations: {
    setCurrentUser(state, val) {
      state.currentUser = val
      state.userRef = fb.usersCollection.doc(val.uid)
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    addQuest(state, doc) {
      let data = doc.data()
      data._ref = doc

      Vue.set(state.quests_by_id, doc.id, data)

      let parent_arr = []
      if (data.parent) {
        state.quests_by_id[data.parent.id].children.push(doc.ref)
        parent_arr = state.quest_to_parents[data.parent.id].concat(data.parent.id)
      }
      Vue.set(state.quest_to_parents, doc.id, parent_arr)
      state.quest_order = getQuestOrder(state.quests_by_id)
    },
    addLog(state, doc) {
      let data = doc.data()
      data._ref = doc
      state.logs.push(data)
      if (data.objective) { state.objectives_by_id[data.objective.id].logs.push(doc.ref) }
    },
    setQuests (state, val) {
      state.quests_by_id = val
      state.quest_to_parents = questParentLookup(val)
      state.quest_order = getQuestOrder(state.quests_by_id)
    },
    addObjective (state, doc) {
      let data = doc.data()
      state.objectives_by_id[doc.id] = data
      state.objectives_by_id[doc.id]._ref = doc
      state.quests_by_id[data.parent.id].objectives.push(doc.ref)
    },
    deleteObjective (state, oid) {
      deleteObjectiveFromParent(state, oid)
      delete state.objectives_by_id[oid]
    },
    setObjectives (state, val) {
      state.objectives_by_id = val
    },
    setLogs (state, val) {
      if (val) {
        state.logs = val
      } else {
        state.logs = []
      }
    },
    updateQuest(state, val) {
      let qid = val[0]
      let data = val[1]

      let q = state.quests_by_id[qid]

      state.quests_by_id[qid].title = data.title
      state.quests_by_id[qid].description = data.description

      let previous_parent = state.quests_by_id[qid].parent

      state.quests_by_id[qid].parent = data.parent

      if (previous_parent != data.parent) {
        let i = state.quests_by_id[previous_parent.id].children.indexOf(q._ref.ref)
        if (i >= 0) {
          state.quests_by_id[previous_parent.id].children.splice(i, 1)
        }
        state.quests_by_id[data.parent.id].children.push(q._ref.ref)
        state.quest_to_parents = questParentLookup(state.quests_by_id)
      }
    },
    deleteQuest (state, q) {
      if (state.quests_by_id[q._ref.id].parent) {
        let parentQuest = state.quests_by_id[state.quests_by_id[q._ref.id].parent.id]
        let i = parentQuest.children.indexOf(q._ref.ref)
        if (i >= 0) {
          parentQuest.children.splice(i, 1)
        }
      }
      delete state.quests_by_id[q._ref.id]
      delete state.quest_to_parents[q._ref.id]
    },
    deleteLog (state, logRef) {
      for (let i = 0; i < state.logs.length; i++) {
        if (state.logs[i]._ref.id == logRef._ref.id) {
          state.logs.splice(i, 1)
          break
        }
      }

      if (logRef.objective) {
        let obj = state.objectives_by_id[logRef.objective.id]
        for (let i = 0; i < obj.logs.length; i++) {
          if (obj.logs[i].id == logRef._ref.id) {
            obj.logs.splice(i, 1)
            break
          }
        }
      }
    },
    updateObjective (state, val) {
      let oid = val[0]
      let data = val[1]

      let obj = state.objectives_by_id[oid]

      if ('title' in data) {
        obj.title = data.title
      }
      if ('description' in data) {
        obj.description = data.description
      }
      if ('items' in data) {
        Vue.set(obj, 'items', data.items)
        console.log('setting items', obj.items)
      }

      if ('complete' in data) {
        Vue.set(obj, 'complete', data.complete)
      }

      if ('parent' in data && obj.parent != data.parent) {
        deleteObjectiveFromParent(state, obj._ref.ref.id)
        state.quests_by_id[data.parent.id].objectives.push(obj._ref.ref)
      }
    },
    updateLog (state, val) {
      let lid = val[0]
      let data = val[1]
      for (let i = 0; i < state.logs.length; i++) {
        if (state.logs[i]._ref.id == lid) {
          state.logs[i].description = data.description
          state.logs[i].items = data.items
          state.logs[i].date = data.date
          break
        }
      }
    }
  },
  actions: {
    clearData({ commit }) {
      commit('setCurrentUser', null)
      commit('setUserProfile', {})
    },
    fetchUserProfile ({ commit, state }) {
      fb.usersCollection
        .doc(state.currentUser.uid)
        .get()
        .then(res => {
          if (!res.data()) {
            var data = {
              name: 'unnamed',
              email: state.currentUser.email
            }
            fb.usersCollection
              .doc(state.currentUser.uid)
              .set(data)
            commit('setUserProfile', data)
          } else {
            commit('setUserProfile', res.data())
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    updateProfile ({ commit, state }, data) {
      let name = data.name

      fb.usersCollection
        .doc(state.currentUser.uid)
        .update({ name: name })
        .catch(err => {
          console.log(err)
        })
    },
    refreshQuests ({ commit, state }) {
      state.userRef.collection('quests')
        .orderBy('title', 'asc')
        .get().then(function (results) {
          let quests_by_id = Object()
          results.forEach(doc => {
            let x = doc.data()

            quests_by_id[doc.id] = x
            quests_by_id[doc.id]._ref = doc
          })
          store.commit('setQuests', quests_by_id)
        })
    },
    refreshObjectives ({ commit, state }) {
      state.userRef.collection('objectives')
        .orderBy('created', 'asc')
        .get().then(function (results) {
          let obj_by_id = Object()
          results.forEach(doc => {
            obj_by_id[doc.id] = doc.data()
            obj_by_id[doc.id]._ref = doc
          })
          store.commit('setObjectives', obj_by_id)
        })
    },
    refreshLogs ({ commit, state }) {
      state.userRef.collection('logs').limit(15)
        .orderBy('date', 'desc')
        .get().then(function (results) {
          store.commit('setLogs', copyToArray(results))
        })
    },
    addObjective ({ commit, state }, data) {
      let parent = state.quests_by_id[data.parent]._ref.ref
      let date = fb.firebase.firestore.FieldValue.serverTimestamp()
      let updateData = {
        parent: parent,
        created: date,
        modified: date,
        title: data.title,
        description: data.description,
        active: true,
        complete: data.complete,
        items: data.items,
        logs: []
      }

      state.userRef.collection('objectives').add(updateData).then(function (ref) {
        parent.update({ objectives: fb.firebase.firestore.FieldValue.arrayUnion(ref) })

        // Update store
        ref.get().then(obj => {
          store.commit('addObjective', obj)
        })
      })
    },
    deleteObjective ({ commit, state }, data) {
      let batch = fb.db.batch()

      batch.update(data.ref.parent, {
        objectives: fb.firebase.firestore
          .FieldValue.arrayRemove(data.ref._ref.ref)
      })
      batch.delete(data.ref._ref.ref)

      batch.commit().then(function () {
        store.commit('deleteObjective', data.ref._ref.id)
      })
    },
    updateObjective ({ commit, state }, data) {
      let oid = data.ref._ref.id
      let oref = data.ref._ref.ref

      let parent = state.quests_by_id[data.parent]._ref.ref

      let updateData = {
        title: data.title,
        description: data.description,
        modified: fb.firebase.firestore.FieldValue.serverTimestamp(),
        items: data.items,
        parent: parent,
        complete: data.complete
      }

      let batch = fb.db.batch()

      if (data.ref.parent.id !== parent.id) {
        console.log('upating objective parent', data.ref.parent, parent)
        batch.update(parent, {
          objectives: fb.firebase.firestore.FieldValue.arrayUnion(oref)
        })
        batch.update(data.ref.parent, {
          objectives: fb.firebase.firestore.FieldValue.arrayRemove(oref)
        })
      }
      batch.update(oref, updateData)
      batch.commit().then(function () {
        store.commit('updateObjective', [oid, updateData])
      })
    },
    addQuest ({ commit, state }, data) {
      let date = fb.firebase.firestore.FieldValue.serverTimestamp()
      let parent = data.parent
      if (data.parent) {
        parent = state.quests_by_id[data.parent]._ref.ref
      }

      let updateData = {
        parent: parent,
        title: data.title,
        description: data.description,
        created: date,
        active: true,
        objectives: [],
        children: []
      }
      state.userRef.collection('quests').add(updateData).then(function (ref) {
        if (parent) {
          parent.update({ children: fb.firebase.firestore.FieldValue.arrayUnion(ref) })
        }
        ref.get().then(obj => {
          store.commit('addQuest', obj)
        })
      })
    },
    addLog ({ commit, state }, data) {
      let date = fb.firebase.firestore.FieldValue.serverTimestamp()
      let updateData = {
        date: data.date,
        modified: date,
        items: data.items,
        description: data.description
      }
      if (data.objective) {
        updateData.objective = data.objective._ref.ref
      }
      if (data.markComplete != null) {
        updateData.markComplete = data.markComplete
      }
      state.userRef.collection('logs').add(updateData).then(function (ref) {
        if (data.objective) {
          let updateObjectiveData = {
            logs: fb.firebase.firestore.FieldValue.arrayUnion(ref),
            modified: date,
            items: data.objItems
          }
          if (data.markComplete != null) {
            updateObjectiveData.complete = data.markComplete
          }
          data.objective._ref.ref.update(updateObjectiveData).then(() => {
            store.commit('updateObjective', [data.objective._ref.id, updateObjectiveData])
          })
        }
        ref.get().then(obj => {
          store.commit('addLog', obj)
        })
      })
    },
    updateLog ({ commit, state }, data) {
      let updateData = {
        modified: fb.firebase.firestore.FieldValue.serverTimestamp(),
        date: data.date,
        items: data.items,
        description: data.description,
        markComplete: typeof markComplete === 'boolean' ? data.markComplete : fb.firebase.firestore.FieldValue.delete()
      }
      data.ref._ref.ref.update(updateData).then(function () {
        store.commit('updateLog', [data.ref._ref.id, updateData])
      })
    },
    updateQuest ({ commit, state }, data) {
      let qid = data.ref._ref.id
      let qref = data.ref._ref.ref

      let parent = null
      if (data.parent) {
        parent = state.quests_by_id[data.parent]._ref.ref
      }

      let updateData = {
        title: data.title,
        description: data.description,
        parent: parent,
        modified: fb.firebase.firestore.FieldValue.serverTimestamp()
      }
      let batch = fb.db.batch()

      if (data.ref.parent !== parent) {
        if (parent) {
          batch.update(parent, {
            children: fb.firebase.firestore.FieldValue.arrayUnion(qref)
          })
        }
        if (data.ref.parent) {
          batch.update(data.ref.parent, {
            children: fb.firebase.firestore.FieldValue.arrayRemove(qref)
          })
        }
      }

      batch.update(qref, updateData)

      batch.commit().then(function () {
        store.commit('updateQuest', [qid, updateData])
      })
    },
    deleteQuest ({ commit, state }, data) {
      // ASSUMES THAT QUEST HAS NO CHILDREN AND OBJECTIVES
      let batch = fb.db.batch()

      if (data.ref.parent) {
        batch.update(data.ref.parent, {
          children: fb.firebase.firestore
            .FieldValue.arrayRemove(data.ref._ref.ref)
        })
      }
      batch.delete(data.ref._ref.ref)
      batch.commit().then(function () {
        store.commit('deleteQuest', data.ref)
      })
    },
    deleteLog ({ commit, state }, data) {
      let batch = fb.db.batch()

      if (data.ref.objective) {
        batch.update(data.ref.objective, {
          logs: fb.firebase.firestore
            .FieldValue.arrayRemove(data.ref._ref.ref)
        })
      }
      console.log('deleting', data.ref)
      batch.delete(data.ref._ref.ref)
      batch.commit().then(function () {
        store.commit('deleteLog', data.ref)
      })
    },
    refreshAll ({ commit, state }) {
      refreshAll()
    }
  }
})
